export const SCALING_FACTOR = 1.02;
export const DROP_ANIMATION_DURATION = 300;
export const DND_VERTICAL_MARGIN = 8;
